<template>
  <div class="signUpFormContainer">
    <h2
      class="title signUpFormTitle has-text-centered"
    >Sign-up Form</h2>
    <h2
      class="subtitle signUpFormSubtitle has-text-centered"
    >Your journey to more members starts here.</h2>
    <transition
      :css="false"
      @enter="enter"
      @leave="leave"
      @before-enter="beforeEnter"
      mode="out-in"
    >
      <div v-if="currentTab === 0" key="0">
        <div class="field signUpElement">
          <p class="control has-icons-left has-icons-right">
            <input
              type="text"
              :class="['input', registerForm.name ? 'validBorder' : null]"
              placeholder="Name"
              @keyup.enter="nameNext($event)"
              v-model="registerForm.name"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
            </span>
            <span v-if="registerForm.name" class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="icon is-small is-right">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </div>
        <h3 class="errorMessage">{{nameMessage}}</h3>
        <div class="field signUpElement">
          <p class="control">
            <button
              class="button search-button slide-left has-text-centered next-button bold"
              @click.prevent="nameNext($event)"
            >Next</button>
          </p>
        </div>
      </div>
      <div v-else-if="currentTab === 1" key="1">
        <div class="field signUpElement">
          <p class="control has-icons-left has-icons-right">
            <input
              type="email"
              :class="['input', validEmail && !emailMessage ? 'validBorder' : registerForm.email ? 'invalidBorder' : null]"
              placeholder="Email"
              v-model="registerForm.email"
              @keyup.enter="emailNext($event)"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-envelope"></i>
            </span>
            <span v-if="validEmail && !emailMessage" class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="icon is-small is-right">
              <i class="fas fa-times"></i>
            </span>
          </p>
          <h3 v-show="emailMessage" class="errorMessage">{{ emailMessage }}</h3>
        </div>
        <div class="field signUpElement">
          <div class="columns is-mobile">
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="decrement()"
              >Back</button>
            </div>
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="emailNext($event)"
              >Next</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="currentTab === 2" key="2">
        <div class="field signUpElement">
          <p class="control has-icons-left has-icons-right">
            <input
              type="password"
              :class="['input', registerForm.password.length > 7 ? 'validBorder' : registerForm.password ? 'invalidBorder' : null]"
              placeholder="Password"
              v-model="registerForm.password"
              @input="passwordStrengthCalc()"
              @keyup.enter="passwordNext($event)"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-lock-open"></i>
            </span>
            <span v-if="registerForm.password.length > 7" class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="icon is-small is-right">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </div>
        <div class="field signUpElement">
          <p class="control has-icons-left has-icons-right">
            <input
              type="password"
              :class="['input', registerForm.password === registerForm.confirmPassword && registerForm.confirmPassword.length > 7  ? 'validBorder' : registerForm.confirmPassword ? 'invalidBorder' : null]"
              placeholder="Confirm Password"
              @keyup.enter="passwordNext($event)"
              v-model="registerForm.confirmPassword"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-lock"></i>
            </span>
            <span
              v-if="registerForm.password === registerForm.confirmPassword && registerForm.confirmPassword" 
              class="icon is-small is-right"
            >
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="icon is-small is-right">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </div>
        <h3
          v-if="registerForm.password"
          :style="{ color: passwordStrength }"
          class="passwordStrength"
        >
          Your password strength is:
          {{
          passwordStrength
          ? passwordStrength === "red"
          ? "weak"
          : passwordStrength === "orange"
          ? "medium"
          : "strong"
          : null
          }}
        </h3>
        <h3 v-show="passwordMessage" class="errorMessage">{{ passwordMessage }}</h3>
        <div class="field signUpElement">
          <div class="columns is-mobile">
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="decrement($event)"
              >Back</button>
            </div>
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="passwordNext($event)"
              >Next</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="currentTab === 3" key="3">
        <div class="field signUpElement">
          <p class="control has-icons-left has-icons-right">
            <input
              type="text"
              :class="['input', validPhone ? 'validBorder' : registerForm.phone_number ? 'invalidBorder' : null]"
              placeholder="Phone Number"
              v-model="registerForm.phone_number"
              @keyup.enter="phoneNext($event)"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-phone"></i>
            </span>
            <span v-if="validPhone" class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="icon is-small is-right">
              <i class="fas fa-times"></i>
            </span>
          </p>
          <h3 v-show="phoneMessage" class="errorMessage">{{ phoneMessage }}</h3>
        </div>
        <div class="field signUpElement">
          <div class="columns is-mobile">
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="decrement($event)"
              >Back</button>
            </div>
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="phoneNext($event)"
              >Next</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="currentTab === 4" key="4">
        <div class="field signUpElement">
          <p class="control has-icons-left has-icons-right">
            <input
              type="text"
              :class="['input', registerForm.company_name ? 'validBorder' : null]"
              placeholder="Company Name"
              v-model="registerForm.company_name"
              @keyup.enter="register($event)"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-building"></i>
            </span>
            <span v-if="registerForm.company_name" class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="icon is-small is-right">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </div>
        <div class="field signUpElement">
          <p class="control has-icons-left has-icons-right">
            <textarea
              type="text"
              :class="['textarea', 'input', 'company-address-input', 'has-fixed-size', registerForm.company_address ? 'validBorder' : null]"
              placeholder="Company Address"
              rows="3"
              v-model="registerForm.company_address"
            ></textarea>
            <span class="icon is-small is-left">
              <i class="fas fa-address-card"></i>
            </span>
            <span v-if="registerForm.company_address" class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="icon is-small is-right">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </div>
        <h3 class="errorMessage">{{ errorMessage || "" }}</h3>
        <div class="field signUpElement">
          <div class="columns is-mobile">
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="decrement()"
              >Back</button>
            </div>
            <div class="column">
              <button
                class="button search-button slide-left has-text-centered next-button bold"
                @click.prevent="register($event)"
              >Register</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Velocity from "velocity-animate";

export default {
  data() {
    return {
      emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      phoneRegex: /(((\+44)? ?(\(0\))? ?)|(0))( ?[0-9]{3,4}){3}/,

      registerForm: {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone_number: "",
        company_name: "",
        company_address: ""
      },
      errorMessage: undefined,
      emailMessage: undefined,
      nameMessage: undefined,
      passwordStrength: undefined,
      phoneMessage: undefined,
      currentTab: 0,
      direction: 1,
      passwordMessage: undefined
    };
  },
  computed: {
    validEmail() {
      return this.emailRegex.test(this.registerForm.email);
    },
    validPhone() {
      return this.phoneRegex.test(this.registerForm.phone_number);
    }
  },
  methods: {
    async emailNext(event) {   
      event.target.blur();
      if (this.validEmail) {
        try {
          const lowerCaseEmail = this.registerForm.email.toLowerCase();
          await this.$http.get(`/api/users/email/${lowerCaseEmail}`);
          this.emailMessage = undefined;
          this.increment();
        } catch (error) {
          if(error.response.data.message) {
            this.emailMessage = error.response.data.message;
          } else {
            this.emailMessage = "Something went wrong, please try again";
          }
        }
      } else {
        this.emailMessage = "Please enter a valid email";
      }
    },
    nameNext(event) {
      if (this.registerForm.name.length == 0) {
        this.nameMessage = "Please enter your name";
        event.target.blur();
      } else {
        this.nameMessage = undefined;
        this.increment();
      }
    },
    passwordNext(event) {
      this.passwordStrengthCalc();
      if (
        this.registerForm.password.length < 8 &&
        this.passwordStrength !== "red"
      ) {
        this.passwordMessage = "Password must be a minimum of 8 characters";
        event.target.blur();
      }
      if (
        this.registerForm.password.length < 8 &&
        this.passwordStrength == "red"
      ) {
        this.passwordMessage =
          "Password must be a minimum of 8 characters and must contain either a number or a capital letter";
        event.target.blur();
      }
      if (this.passwordStrength == "red") {
        this.passwordMessage =
          "Password must contain either a number or a capital letter";
        event.target.blur();
      }
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.passwordMessage = "Passwords don't match";
        event.target.blur();
      }
      if (
        this.registerForm.password &&
        this.registerForm.password == this.registerForm.confirmPassword &&
        this.registerForm.password.length >= 8 &&
        this.passwordStrength !== "red"
      ) {
        this.passwordMessage = "";
        this.increment();
      }
    },
    phoneNext(event) {
      if (!this.validPhone) {
        this.phoneMessage = "Please enter a valid phone number";
        event.target.blur();
      } else {
        this.phoneMessage = undefined;
        this.increment();
      }
    },
    async register(event) {
      event.target.blur();
      let nonEmpty = Object.keys(this.registerForm).every(
        key => this.registerForm[key]
      );
      if (!nonEmpty) {
        this.errorMessage = "Please fill in all required fields";
      }
      if (nonEmpty) {
        if (!this.phoneRegex.test(this.registerForm.phone_number)) {
          this.errorMessage = "Please enter a valid phone number";
        } else {
          this.errorMessage = undefined;
          let userToBeCreated = this.registerForm;
          delete userToBeCreated.confirmPassword;
          try {
            await this.$http.post("/api/users", userToBeCreated);
          } catch (error) {
            this.errorMessage =
              "Sorry, something went wrong, please try again later.";
            throw "Something went wrong" + error;
          }
          this.$emit("success", { email: this.registerForm.email, password: this.registerForm.password });
          this.registerForm = {
            name: "",
            email: "",
            password: "",
            confirmPassword: "",
            phone_number: "",
            company_name: "",
            company_address: ""
          };
          // Object.keys(this.registerForm).map(key => this.registerForm[key] = '');
        }
      }
    },
    passwordStrengthCalc() {
      let strongPasswordRegex = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
      );
      let mediumPasswordRegex = new RegExp(
        "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})"
      );
      if (strongPasswordRegex.test(this.registerForm.password)) {
        this.passwordStrength = "green";
      } else if (mediumPasswordRegex.test(this.registerForm.password)) {
        this.passwordStrength = "orange";
      } else {
        this.passwordStrength = "red";
      }
    },
    increment() {
      this.direction = 1;
      this.currentTab++;
      setTimeout(() => {
        let input = this.$el.querySelector("input");
        input.focus();
      }, 1000);
    },
    decrement() {
      this.direction = -1;
      this.currentTab--;
      setTimeout(() => {
        let input = this.$el.querySelector("input");
        input.focus();
      }, 1000);
    },
    beforeEnter(el) {
      el.style.opacity = 0;
      // if (this.direction === -1) {
        // Velocity(el, { translateX: "-110%" }, { duration: 1 });
      // } else {
        // Velocity(el, { translateX: "110%" }, { duration: 1 });
      // }
    },
    enter(el, done) {
      Velocity(el, { opacity: 1 }, { duration: 500, complete: done });
      // if (this.direction === -1) {
        // Velocity(
        //   el,
        //   { translateX: "0%", opacity: 1 },
        //   { duration: 500, complete: done }
        // );
        // Velocity(el, { opacity: 1 }, { duration: 500, complete: done });
      // } else {
        // Velocity(
        //   el,
        //   { translateX: "0%", opacity: 1 },
        //   { duration: 500, complete: done }
        // );
        // Velocity(el, { opacity: 1 }, { duration: 500, complete: done });
      // }
    },
    leave(el, done) {
      Velocity(el, { opacity: 0 }, { duration: 500, complete: done });
      // if (this.direction === -1) {
        // Velocity(
        //   el,
        //   { translateX: "110%", opacity: 0 },
        //   { duration: 500, complete: done }
        // );
        // Velocity(el, { opacity: 0 }, { duration: 500, complete: done });
      // } else {
        // Velocity(
        //   el,
        //   { translateX: "-110%", opacity: 0 },
        //   { duration: 500, complete: done }
        // );
      //   Velocity(el, { opacity: 0 }, { duration: 500, complete: done });
      // }
    }
  }
};
</script>

<style>
.company-address-input {
  border-radius: 16px !important;
  border: 1px solid black;
}

.errorMessage {
  font-size: 1rem;
  color: red;
  margin: 0 auto;
  width: fit-content;
}

.signUpFormContainer {
  width: 40rem;
}

.next-button {
  z-index: 1;
  width: 100%;
  padding: 0;
  margin: auto !important;
}

.signUpFormTitle {
  font-size: calc(1rem + 0.5vw);
  color: black;
}

.signUpFormSubtitle {
  /* width: 50%; */
  /* font-size: calc(1rem + 0.5vw); */
  /* -webkit-text-stroke: 1px black; */
  color: black;
}

.passwordStrength {
  margin: 0 auto;
  width: fit-content;
}

.passwordMessage {
  color: red;
}

.signUpElement {
  width: 80%;
  margin: 1rem auto;
  z-index: -1;
}

.errorMessage {
  color: red;
  padding: 0 1rem;
  text-align: center;
}

.register-button {
  width: 50%;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
}

.slide-leave-to {
  transform: translateX(-110%);
}

.validBorder {
  border-color: #48c774 !important;
}

.invalidBorder {
  border-color: #f14668 !important;
}

.slide-enter {
  transform: translateX(110%);
}

@media only screen and (max-width: 768px) {
  .signUpFormContainer {
    width: 80vw;
  }
}
</style>
